import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Prazdny stav je soucast navrhu kazde obrazovky (ustava kitu) — rika, co tu
 * bude, proc to je prazdne a co udelat ted. Texty dodava produkt (i18n).
 */
export function EmptyState({ title, description, icon, action, className }) {
    return (_jsxs("div", { role: "status", className: `rh-empty${className ? ` ${className}` : ''}`, children: [icon ? (_jsx("div", { className: "rh-empty__icon", "aria-hidden": "true", children: icon })) : null, _jsx("p", { className: "rh-empty__title", children: title }), description ? _jsx("p", { className: "rh-empty__description", children: description }) : null, action ? _jsx("div", { className: "rh-empty__action", children: action }) : null] }));
}
//# sourceMappingURL=empty-state.js.map